module.exports = __webpack_public_path__ + "img/2.5eb871b9.jpg";